<template>
  <main :class="pageData ? '' : 'loading'">
    <page-header :title="headerTitle" :image="headerImage"></page-header>
    <pencils-change-lives :content="pageContent"></pencils-change-lives>
    <more-stories :stories="moreStories"></more-stories>
  </main>
</template>

<script>
import PageHeader from './layouts/PageHeader'
import PencilsChangeLives from './OurStory/PencilsChangeLives'
import MoreStories from './OurStory/MoreStories'

export default {
  name: 'our-story',
  data () {
    return {
      headerTitle: 'Our Story',
      headerImage: 'PFK_OurStory_Photo1_800x290.jpg',
      pageData: null
    }
  },
  components: {
    PageHeader,
    PencilsChangeLives,
    MoreStories
  },
  mounted () {
    this.getPageData()
  },
  methods: {
    getPageData () {
      const vm = this
      vm.$http.get('/pages?slug=our-story')
      .then((response) => {
        vm.pageData = response.data[0]
      })
    }
  },
  computed: {
    moreStories () {
      if (this.pageData && this.pageData.acf) return this.pageData.acf.more_stories
    },
    pageContent () {
      if (this.pageData) return this.pageData.content.rendered
    }
  }
}
</script>



// WEBPACK FOOTER //
// OurStory.vue?6c234ad6